import PaginationView from "../view/pagination.js";
import PaginationLinkView from "../view/pagination-link.js";
import LoadButtonView from "../view/load-button.js";

import ScrollToElement from "../../../../scroll-to-element/scroll-to-element.js";

import {
  replace,
  createElement,
  removeElement,
  render
} from "../../../../render/render.js";

import {
  PAGINATION_KEY
} from "../../../const.js";
export default class Pagination {
  constructor(element, parent, changeFilter, wrapperView, browserNavigation) {
    this._view = new PaginationView(element, parent);
    this._changeFilter = changeFilter;
    this._wrapperView = wrapperView;
    this._browserNavigaion = browserNavigation;

    this._scrollToElement = new ScrollToElement();

    this._paginationLinks = [];
    this._loadButtonView = null;

    this._updatePagination = this._updatePagination.bind(this);
    this._handlePaginationLinkClick = this._handlePaginationLinkClick.bind(this);
    this._handleLoadButtonClick = this._handleLoadButtonClick.bind(this);
    this._handleChangeFilterLoadEnd = this._handleChangeFilterLoadEnd.bind(this);
  }

  init() {
    this._changeFilter.addLoadObserver(this._updatePagination);
    this._initLinks();
    this._initLoadButton();
  }

  _initLoadButton() {
    if (!this._view) {
      return;
    }

    const loadButtonElement = this._view.getLoadButton();

    if (!loadButtonElement) {
      return;
    }

    this._loadButtonView = new LoadButtonView(loadButtonElement);
    this._loadButtonView.setClickHandler(this._handleLoadButtonClick);
    this._changeFilter.addLoadEndObserver(this._handleChangeFilterLoadEnd);
  }

  _initLinks() {
    if (!this._view) {
      return;
    }

    const linksElements = this._view.getLinksElements();

    if (linksElements.length === 0) {
      return;
    }

    this._paginationLinks = [];

    Array.from(linksElements)
      .forEach((link) => {
        const linkView = new PaginationLinkView(link);
        linkView.setClickHandler(this._handlePaginationLinkClick);
        this._paginationLinks.push(linkView);
      });
  }

  _updatePagination(data) {
    const pagination = data.pagination;

    if (!pagination && this._view.getElement()) {
      removeElement(this._view.getElement());
      this._view.updateElement(null);
      return;
    }

    if (!pagination) {
      return;
    }

    const newPaginationElement = createElement(pagination);

    if (!this._view.getElement()) {
      render(this._view.getParentElement(), newPaginationElement);
    } else {
      replace(newPaginationElement, this._view.getElement());
    }

    this._view.updateElement(newPaginationElement);
    this._initLinks();
    this._initLoadButton();
  }

  _handleLoadButtonClick() {
    this._loadButtonView.makeLoading();

    // Updating the products data.
    this._changeFilter.updateProductsData({
      byButton: true
    });
  }

  _handleChangeFilterLoadEnd() {
    this._loadButtonView.reset();
    this._changeFilter.removeLoadEndObserver(this._handleChangeFilterLoadEnd);
  }

  _handlePaginationLinkClick(evt) {
    const page = +evt.target.href
      .replace(/(.*\?)/i, ``)
      .split(`&`)
      .map((item) => {
        item = item.split(`=`);

        return {
          name: item[0],
          value: item[1]
        };
      })
      .filter((item) => {
        return item.name === PAGINATION_KEY;
      })
      .map((item) => {
        return item.value;
      })
      .join(``);

    this._changeFilter.updateProductsData({
      page
    });
    this._scrollToElement.scroll({
      element: this._wrapperView.getElement()
    });
  }
}
